import { useGetCountry } from '../helpers';

const useContactInformation = () => {
  const country = useGetCountry();
  if (country === 'Mexico') {
    return {
      mail: 'contacto@fingo.com.mx',
      phoneNumber: '+52 56 4861 2937',
      address: 'Varsovia No. 36 Piso 4, Int. 408, Colonia Juárez C.P. 6600, Ciudad de México',
    };
  }
  return {
    mail: 'contacto@fingo.cl',
    phoneNumber: '+56 9 6246 4446',
    address: 'Av. Apoquindo 4660 Piso 8, Las Condes',
  };
};

export default useContactInformation;
